import { motion } from "framer-motion";

export const SkyjoMark = ({ compact = false }: { compact?: boolean }) => (
  <span className={`skyjo-mark${compact ? " skyjo-mark--compact" : ""}`} aria-hidden="true">
    <span className="skyjo-mark__card skyjo-mark__card--blue" />
    <span className="skyjo-mark__card skyjo-mark__card--yellow" />
    <span className="skyjo-mark__card skyjo-mark__card--red" />
  </span>
);

export const Brand = ({ compact = false }: { compact?: boolean }) => (
  <motion.div
    className={`brand${compact ? " brand--compact" : ""}`}
    initial={{ opacity: 0, y: -6 }}
    animate={{ opacity: 1, y: 0 }}
  >
    <SkyjoMark compact={compact} />
    <span className="brand__word">Skyjo</span>
    {!compact && <span className="brand__tagline">vise le plus petit score</span>}
  </motion.div>
);
